module.exports = __webpack_public_path__ + "static/img/bankz.69e5bf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spreader/bankz.jpg
// module id = 74cL
// module chunks = 1